(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-publication"] && !Shopify.designMode) return;
  try {
    

(function () {
  function applyArticleTint(root) {
    const source = root.dataset.nvTintImage;
    if (!source || root.dataset.nvTintLoaded === source) return;
    root.dataset.nvTintLoaded = source;
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      if (!root.isConnected) return;
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 64;
        canvas.height = 64;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return;
        context.drawImage(image, 0, 0, 64, 64);
        const pixels = context.getImageData(0, 0, 64, 64).data;
        const bins = new Map();
        let chromaticPixels = 0;
        for (let i = 0; i < pixels.length; i += 4) {
          if (pixels[i + 3] < 128) continue;
          const r = pixels[i] / 255, g = pixels[i + 1] / 255, b = pixels[i + 2] / 255;
          const max = Math.max(r, g, b), min = Math.min(r, g, b), delta = max - min;
          const lightness = (max + min) / 2;
          const saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));
          if (saturation < 0.18 || lightness < 0.1 || lightness > 0.92) continue;
          let hue = max === r ? ((g - b) / delta) % 6 : max === g ? (b - r) / delta + 2 : (r - g) / delta + 4;
          hue = (hue * 60 + 360) % 360;
          const key = Math.round(hue / 20) % 18;
          const bin = bins.get(key) || { count: 0, saturation: 0, x: 0, y: 0 };
          bin.count++;
          bin.saturation += saturation;
          bin.x += Math.cos(hue * Math.PI / 180);
          bin.y += Math.sin(hue * Math.PI / 180);
          bins.set(key, bin);
          chromaticPixels++;
        }
        let dominant, bestScore = 0;
        for (const bin of bins.values()) {
          if (bin.count < 64) continue;
          const score = bin.count * (0.4 + bin.saturation / bin.count);
          if (score > bestScore) { dominant = bin; bestScore = score; }
        }
        let tint = 'hsl(0 0% 95%)';
        if (dominant && chromaticPixels >= 100) {
          const hue = (Math.atan2(dominant.y, dominant.x) * 180 / Math.PI + 360) % 360;
          const saturation = Math.max(40, Math.min(70, dominant.saturation / dominant.count * 100));
          tint = 'hsl(' + Math.round(hue) + ' ' + Math.round(saturation) + '% 94%)';
        }
        root.style.setProperty('--nv-article-bg', tint);
      } catch (_) {}
    };
    image.src = source;
  }
  function initialize(scope) {
    if (scope.matches?.('[data-nv-tint-image]')) applyArticleTint(scope);
    scope.querySelectorAll('[data-nv-tint-image]').forEach(applyArticleTint);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
